import React, { useState } from 'react';
import styles from './styles.scss';
import { useTranslation } from 'react-i18next';
import { Phone } from './Phone';
import { Code } from './Code';
import { Steps, Types } from './common';
import { FormRegistration } from '../../../components/Login';
import TechnicalProblem from './TechnicalProblem';

export const Form = () => {
  const [step, setStep] = useState(Steps.Phone);
  const [type, setType] = useState(Types.Call);
  const [showRegistration, setShowRegistration] = useState(false);
  const [isTechnicalProblem, setIsTechnicalProblem] = useState(false);
  const [phone, setPhone] = useState('');
  const { t } = useTranslation();

  const goToCodeStep = () => setStep(Steps.Code);
  const goToPhoneStep = () => setStep(Steps.Phone);

  const toggleRegistration = () => setShowRegistration(prev => !prev);

  return (
    <React.Fragment>
      <div className={styles.LoginForm}>
        <div className={styles.LoginFormTitle}>
          {t(`containers.logIn.title-${step}`)}
        </div>
        <div className={styles.LoginFormSubTitle}>
          {t(`containers.logIn.subtitle-${step}`)}
        </div>
        {step === Steps.Phone ? (
          <Phone
            showRegistration={toggleRegistration}
            goToCodeStep={goToCodeStep}
            goToPhoneStep={goToPhoneStep}
            type={type}
            phone={phone}
            setType={setType}
            setPhone={setPhone}
            showErrorModal={() => setIsTechnicalProblem(true)}
          />
      ) : (
        <Code
          phone={phone}
          type={type}
          goToPhoneStep={goToPhoneStep}
        />
      )}
      </div>
      {showRegistration &&
        <div className={styles.Registration}>
          <FormRegistration
            phone={phone}
            handleRegistrationSuccessfully={() => setShowRegistration(false)}
            handleRegistrationError={() => setIsTechnicalProblem(true)}
            handleCloseModal={() => setShowRegistration(false)}
          />
        </div>
      }
      {isTechnicalProblem && (
        <TechnicalProblem
          type={type}
          handleCloseModal={() => setIsTechnicalProblem(false)}
        />
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Login/Form/index.js